import React, { Component } from "react"
import PropTypes from "prop-types"
import _ from "lodash"
import { Card } from "semantic-ui-react"
import shop from "shop/shop"
import ProductSlider from "components/Product/ProductSlider"

class ProductList extends Component {

  static defaultProps = {
    itemsPerRow: 4,
    center:      false
  }

  constructor( props ) {
    super( props )
    this.state = {
      products: [],
      list:     []
    }
  }

  componentWillReceiveProps( props ) {
    if ( props.list !== this.state.list ) {
      this.load( props )
    }

    this.setState( props )
  }

  componentDidMount() {
    this.load( this.props )
  }

  load( props = this.props ) {
    shop.products.list( _.uniq( props.list ) )
      .then( products => {
        //console.log(`ProductList::loaded`, products)
        this.setState( { products } )
      } )
  }

  render() {
    let { sm, md, xs, lg, title, displayMode } = this.props
    const { products } = this.state
    let Child = this.props.repeat
    //console.log("ProductList::render", this.props, products)
    if(products.length >= 4 || (displayMode === "mobile" && products.length > 2)) {
      displayMode = "slider"
    }
    else{
      displayMode = "cards"
    }
    let out = null

    switch ( displayMode ) {
      case "cards":
        out = <Card.Group itemsPerRow="4">
          {products.map( product => <Child key={product.map_id}
                                           product={product}/> )
          }
        </Card.Group>
        break;

      case "grid":
        out = <Card.Group itemsPerRow="4">
          {products.map( product => <Child key={product.map_id}
                                           product={product}/> )
          }
        </Card.Group>
        break;

      case "list":
        out = <Card.Group itemsPerRow="4">
          {products.map( product => <Child key={product.map_id}
                                           product={product}/> )
          }
        </Card.Group>
        break;

      case "slider":
        out = <div>
          <ProductSlider Card={Child} products={products}/>
        </div>
        break;



    }

    return (
      <div>
        {(title) ? <div className="row-title"><h2>{title}</h2></div> : null}
        {out}
      </div>
    )
  }
}

ProductList.propTypes = {
  list:   PropTypes.array,
  xs:     PropTypes.string,
  sm:     PropTypes.string,
  md:     PropTypes.string,
  lg:     PropTypes.string,
  title:  PropTypes.string,
  repeat: PropTypes.any.isRequired

}

export default ProductList



// WEBPACK FOOTER //
// ./src/components/Product/ProductList.js